import { createStore } from '../utils/stores';
function removeItem(arr, i) {
    const index = arr.findIndex((v) => v.item === i);
    if (index > -1) {
        arr.splice(index, 1);
    }
}
function addTx(arr, i) {
    arr.push({ type: 'transaction', item: i });
}
function addSig(arr, i) {
    arr.push({ type: 'signature', item: i });
}
export function createPendingActionsStore() {
    const { $state, set, readable } = createStore({
        list: [],
    });
    const observers = {
        onTxRequested(tx) {
            addTx($state.list, tx);
            set({ list: $state.list });
        },
        onTxCancelled(tx) {
            removeItem($state.list, tx);
            set({ list: $state.list });
        },
        onTxSent(tx, hash) {
            removeItem($state.list, tx);
            set({ list: $state.list });
        },
        onSignatureRequest(request) {
            addSig($state.list, request);
            set({ list: $state.list });
        },
        onSignatureCancelled(request) {
            removeItem($state.list, request);
            set({ list: $state.list });
        },
        onSignatureResponse(request, signature) {
            removeItem($state.list, request);
            set({ list: $state.list });
        },
    };
    function skip() {
        $state.list.shift();
        set({ list: $state.list });
    }
    const store = {
        ...readable,
        skip,
    };
    return { pendingActions: store, observers };
}
